import { render, staticRenderFns } from "./MemberStats.vue?vue&type=template&id=0446eb1d&scoped=true&"
import script from "./MemberStats.vue?vue&type=script&lang=js&"
export * from "./MemberStats.vue?vue&type=script&lang=js&"
import style0 from "@/styles/stats.css?vue&type=style&index=0&id=0446eb1d&scoped=true&lang=css&"
import style1 from "./MemberStats.vue?vue&type=style&index=1&id=0446eb1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0446eb1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
